import Swal from "sweetalert2";
import { Apis } from "../../lib/Apis";

export const homeScreenData = () => {
    const getHomeScreenData = async (setHomeScreen) => {
        try {
            const resposne = await Apis.getHomeScreenData();
            setHomeScreen(resposne.data);
            return resposne.data;
        } catch (error) {
            console.error("Error fetching home screen data:", error);
            return null;
        }
    }
    const postHomeScreenData = async (data) => {
        try {
            const resposne = await Apis.postHomeScreenData(data);
            if (resposne.data) {
                Swal.fire({
                    title: "Success!",
                    text: "Data has been successfully added!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Something went wrong!",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
            return resposne.data;
        } catch (error) {
            console.error("Error updating home screen data:", error);
            return null;
        }
    }
    const deleteHomeScreenData = async (id) => {
        try {
            const resposne = await Apis.deleteHomeScreenData(id);
            return resposne.data;
        } catch (error) {
            console.error("Error deleting home screen data:", error);
            return null;
        }
    }
    const updateHomeScreen = async (id, status) => {
        try {
            const resposne = await Apis.updateHomeScreenData(id, status);
            return resposne.data;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return null;
        }
    }
    return { getHomeScreenData, postHomeScreenData, deleteHomeScreenData, updateHomeScreen };
}